import { useState } from "react";
import AppointmentTimeSlotPlanItemModal from "./AppointmentTimeSlotPlanItemModal";
import AppointmentTimeSlotPlanItemsList from "./AppointmentTimeSlotPlanItemsList";
import { PlusOutlined } from "@ant-design/icons";
import { AppointmentTimeSlotPlanItemFormValues } from "./AppointmentTimeSlotPlanForm";
import { Button, Card } from "@rumbledirect/ui";

interface AppointmentTimeSlotPlanItemsEditorProps {
  value?: AppointmentTimeSlotPlanItemFormValues[];
  onChange?: (value: AppointmentTimeSlotPlanItemFormValues[]) => void;
  loading?: boolean;
}

export const AppointmentTimeSlotPlanItemsEditor = ({
  value,
  onChange,
  loading,
}: AppointmentTimeSlotPlanItemsEditorProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] =
    useState<AppointmentTimeSlotPlanItemFormValues | null>(null);

  const handleEdit = (item: AppointmentTimeSlotPlanItemFormValues) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSubmit = (planItem: AppointmentTimeSlotPlanItemFormValues) => {
    const planItems = value ? [...value] : [];
    const idx = planItems.findIndex((item) => item._key === planItem._key);
    if (idx !== -1) {
      planItems[idx] = planItem;
    } else {
      planItems.push(planItem);
    }
    onChange?.(planItems);

    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleDelete = (planItem: AppointmentTimeSlotPlanItemFormValues) => {
    const planItems = value ? [...value] : [];
    const filtered = planItems.filter(
      (item) => !(item === planItem || item._key === planItem._key),
    );
    onChange?.(filtered);
  };

  return (
    <Card
      title="Tijdsloten"
      loading={loading}
      extra={
        <Button onClick={() => setIsModalOpen(true)} icon={<PlusOutlined />}>
          Voeg tijdslot toe
        </Button>
      }
    >
      <AppointmentTimeSlotPlanItemsList
        items={value}
        showActions
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <AppointmentTimeSlotPlanItemModal
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setSelectedItem(null);
        }}
        selectedItem={selectedItem}
        onSubmit={handleSubmit}
      />
    </Card>
  );
};

export default AppointmentTimeSlotPlanItemsEditor;
